import axios from 'axios';
import { EncryptStorage } from 'encrypt-storage';
import {
  ENC_STORAGE_USER_KEY,
  SESS_STORAGE_USER_KEY
} from "../utils/enums";

const encryptStorage = new EncryptStorage(import.meta.env.VITE_STORAGE_KEY);
const URL =  import.meta.env.VITE_BASE_URL+import.meta.env.VITE_SUB_BASE_URL+import.meta.env.VITE_API_VERSION;

const api = axios.create({
  baseURL: URL,
});

function getCurrentToken() {
  try {
    const userStorage = encryptStorage.getItem(ENC_STORAGE_USER_KEY);
    const activedTab = JSON.parse(sessionStorage.getItem("uwa-activeTab") || '{}');

    // Prefer active tab token, fallback to storage token
    return activedTab?.token || userStorage?.token || null;
  } catch (error) {
    console.error('Error getting current token:', error);
    return null;
  }
}

api.interceptors.request.use(
  (config) => {
    const token = getCurrentToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

function clearAuthData() {
  try {
    // Set encrypted storage to empty object instead of null
    // to prevent destructuring errors in existing code
    encryptStorage.setItem(ENC_STORAGE_USER_KEY, {
      id: '',
      name: '',
      email: '',
      image: '',
      token: '',
      date_time: ''
    });

    // Set session storage items to empty structures
    encryptStorage.setItem(SESS_STORAGE_USER_KEY, []);
    sessionStorage.setItem('tab_session_id', '');

    sessionStorage.removeItem('is_switched');

    // Clear user tabs
    localStorage.setItem('user_tabs', JSON.stringify({}));
  } catch (error) {
    console.error('Error clearing auth data:', error);
  }
}

function isSwitched() {
  return sessionStorage.getItem('is_switched') === '1';
}

export { api, getCurrentToken, clearAuthData, isSwitched };
